module.exports = __webpack_public_path__ + "img/mobile/BetBar/Menu_button@2x.png?1.0.17";